import DrawerMain from './components/DrawerMain';
import { DrawerProvider } from './contexts/DrawerContext';

interface DrawerProps {
  onBlockingStateChange?: (isBlocking: boolean) => void;
}

const Drawer = ({ onBlockingStateChange }: DrawerProps) => {
  return (<DrawerProvider>
    <DrawerMain onBlockingStateChange={onBlockingStateChange}></DrawerMain>
  </DrawerProvider>);
};
export default Drawer;
